import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CompanyService from "../../../services/companyService";
import Breadcrumb from "../../../components/Breadcrumb";
import ListCompany from "../Components/ListCompany";
import ViewModelCompany from "../Components/ViewModelCompany";
import MessageDialog from "../../../components/MessageDialog";

export default function ViewCompany() {
  const [companies, setCompanies] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO (single select)
  const [searchText, setSearchText] = useState(""); //  SEARCH
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  // const messageTimer = useRef(null);

  const [showViewModal, setShowViewModal] = useState(false);
  const [viewData, setViewData] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await CompanyService.getAllCompany();
      const sorted = (response || []).sort((a, b) => a.id - b.id);

      // frontend pagination
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const paginated = sorted.slice(startIndex, endIndex);

      setCompanies(paginated);
      setPageCount(Math.ceil(sorted.length / itemsPerPage));

    } catch (err) {
      console.error(err);
      showMessage("Error fetching data", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  useEffect(() => {
    if (location.state?.refresh) {
      fetchData();
      navigate(location.pathname, { replace: true });
    }
  }, [location]);

  const handleAdd = () => {
    navigate("/cpnl/company/add");
  };

  const handleModify = () => {
    if (!selected) {
      showMessage("Select one record to modify", "error");
      return;
    }

    const company = companies.find((c) => c.id === selected);
    if (company?.status === "Active") {
      navigate(`/cpnl/company/add/${selected}`);
    } else {
      showMessage("Inactive records cannot be Modified", "error");
    }
  };

  //  RADIO SELECT
  const handleSelect = (id) => {
    setSelected(id);
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };


  const handleToggleStatus = async (company) => {
    const newStatus = company.status === "Active" ? "Inactive" : "Active";

    if (!window.confirm(`Are you sure you want to update status to ${newStatus}?`)) return;

    setLoading(true);
    try {
      await CompanyService.updateStatus(company.id, newStatus);
      showMessage("Status updated successfully", "success");
      fetchData();
    } catch (err) {
      console.error(err);
      showMessage("Error updating status", "error");
    } finally {
      setLoading(false);
    }
  };

  // ======================= HANDLE VIEW ==========================
  const handleView = async () => {
    if (!selected) {
      showMessage("Select one company to view.", "error");
      return;
    }

    try {
      const data = await CompanyService.getById(selected);

      if (!data) {
        showMessage("Failed to load company details", "error");
        return;
      }

      setViewData(data);
      setShowViewModal(true);
    } catch (err) {
      console.error(err);
      showMessage("Error loading company details", "error");
    }
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setViewData(null);
  };

  //  FRONTEND SEARCH FILTER
  const filteredCompanies = companies.filter(
    (c) =>
      c.companyName?.toLowerCase().includes(searchText.toLowerCase()) ||
      c.companyCode?.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <Breadcrumb pageTitle="Company" secondTitle="Masters" />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">

          {/* MESSAGE */}
          {/* {message && (
            <div className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"} d-flex justify-content-between`}>
              <span>{message}</span>
              <button type="button" className="btn-close" onClick={() => setMessage("")}></button>
            </div>
          )} */}
          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          

          {/*  SEARCH + BUTTONS */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Company"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            <div className="ms-auto d-flex gap-2">
              <button className="btn btn-success" onClick={handleAdd} disabled={loading}>
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button className="btn btn-warning" onClick={handleModify} disabled={loading}>
                <i className="ti ti-pencil me-1"></i> Modify
              </button>

              <button className="btn btn-primary" onClick={handleView} disabled={loading}>
                <i className="ti ti-eye me-1"></i> View
              </button>
            </div>
          </div>

          {/* TABLE */}
          <ListCompany
            loading={loading}
            filteredCompanies={filteredCompanies}
            selected={selected}
            handleSelect={handleSelect}
            handleToggleStatus={handleToggleStatus}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />
          <ViewModelCompany
            showViewModal={showViewModal}
            viewData={viewData}
            closeViewModal={closeViewModal}
          />
        </div>
      </div>
    </>
  );
}
